<template>
  <div class="ma-1 ma-sm-4">
    <!-- {{ packageSizes }} -->
    <v-card
      flat
      rounded
      outlined
      class="cardOutline my-0"
      :loading="loading"
      color="#fff8e8"
    >
      <v-card-text class="py-1 px-4">
        <div
          class="d-flex flex-column flex-sm-row justify-space-between align-center"
        >
          <div class="text-h5 darkerCardText">Practice CL Price List</div>
          <v-checkbox
            v-model="filters.compare"
            label="Compare to Online Prices"
            class="pt-0 pt-sm-1 mr-3 my-0"
          ></v-checkbox>
        </div>

        <div class="my-1 d-flex flex-column flex-sm-row align-sm-center">
          <div
            :style="$vuetify.breakpoint.smAndUp ? 'width: 200px' : ''"
            class="mr-3"
          >
            <v-text-field
              clearable
              dense
              :outlined="!$vuetify.breakpoint.smAndUp"
              :rounded="!$vuetify.breakpoint.smAndUp"
              v-model="filters.name"
              label="Filter by name"
              hide-details="auto"
              class="mt-1"
            ></v-text-field>
          </div>
          <type-select
            @type="setFilterValue('type', $event)"
            :external="filters.type"
            class="mt-1 mr-3"
          ></type-select>
          <replace-select
            @replace="setFilterValue('replace', $event)"
            :external="filters.replace"
            class="mt-1 mr-3"
          ></replace-select>
          <div style="width: 150px" class="mr-3">
            <v-select
              v-model="filters.quantity"
              :items="packageSizes"
              label="Pkg Qty"
              dense
              outlined
              clearable
              hide-details="auto"
              rounded
              class="compact-select mt-1"
              width="75"
              background-color="#ffffff80"
            ></v-select>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <div class="caption d-flex flex-row flex-wrap align-center mx-4">
      <div class="mr-4" v-if="filterSummary.length > 0">Filter Summary:</div>

      <v-chip
        x-small
        close
        v-for="row in filterSummary"
        :key="row.filter"
        class="ma-1"
        color="#ececec"
        close-icon="mdi-close"
        @click:close="filters[row.filter] = filterDefaults[row.filter]"
        >{{ row.label }}
      </v-chip>
      <v-spacer></v-spacer>

      <v-btn
        color="red"
        small
        text
        v-if="filterSummary.length > 0"
        @click="resetFilters()"
        ><v-icon small class="mx-1">mdi-close-circle</v-icon>Clear All Filters
      </v-btn>
      <div v-else>(No Filters applied)</div>
    </div>
    <!-- <div v-if="loading">loading . . .</div> -->
    <div>
      <v-data-table
        :loading="loading"
        :headers="headersForSize"
        :items="lensList"
        sort-by="name"
        :items-per-page="25"
        item-key="subId"
        class="dataTable"
      >
        <template v-slot:item.company_id="{ item }">
          <product-image
            type="companyId"
            :companyId="parseInt(item.company_id)"
            :maxHeight="30"
            :maxWidth="100"
          ></product-image>
        </template>

        <template v-slot:item.replace="{ item }">
          <soft-type-icon type="replace" :lens="item" :width="25" />
        </template>

        <template v-slot:item.type="{ item }">
          <soft-type-icon type="type" :lens="item" :width="25" />
        </template>

        <template v-slot:item.rebateId="{ item }">
          <span v-if="item.rebateId > 0" class="green--text"
            >${{ priceData.rebates[item.rebateId].amount }}</span
          >
          <v-icon v-else color="red" small>mdi-minus</v-icon>
        </template>

        <template v-slot:item.onlinePrice="{ item }">
          <span v-if="item.onlinePrice && item.onlinePrice > 0">
            {{ item.onlinePrice | currency }}</span
          >
        </template>
        <template v-slot:item.practicePrice="{ item }">
          <set-price-popup
            :lens_id="item.id"
            :lens_name="item.name"
            @priceChange="updateLensPrice(item.id, $event)"
          >
            <span :class="colorForPrice(item)" style="width: 75px">
              <span v-if="item.practicePrice && item.practicePrice > 0">
                {{ item.practicePrice | currency }}</span
              >
            </span>
            <v-icon x-small color="primary" class="ml-1">mdi-pencil</v-icon>
          </set-price-popup>
        </template>
        <!-- <template v-slot:[`item.edit`]="{}">
         
        </template> -->

        <!-- <template v-slot:[`item.prices.online`]="{ item }">
          <span v-for="(price, qty) in item.prices.online" :key="qty"
            ><div>
              {{ price | currency
              }}<span class="caption lightgray--text">/{{ qty }}</span>
            </div></span
          >
        </template>

        <template v-slot:[`item.prices.practice`]="{ item }">
          <span v-for="(price, qty) in item.prices.practice" :key="qty"
            ><div>
              {{ price }}
              <span class="caption lightgray--text">/{{ qty }}</span>
            </div></span
          >
        </template> -->
      </v-data-table>
    </div>
    <!-- <div>{{ priceData }}</div> -->
    <div class="mt-8 caption" v-if="priceData">
      <sup>*</sup> Online prices are provided as a reference. Every effort is
      made to keep these prices up-to-date, but factors outside of EyeDock's
      control may impact our ability to do this. Also, be aware that the prices
      presented here are prices per box. Other rebates and discounts may be
      offered in the final price.
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";
import ApiServices from "@/services/ApiServices";
import UserMixin from "@/assets/js/UserMixin";
import ClCompanyMixin from "@/assets/js/cls/ClCompanyMixin";
import SetPricePopup from "@/components/clPricesStuff/SetPricePopup";
import SoftTypeIcon from "@/components/clStuff/SoftTypeIcon";
import ProductImage from "@/components/clStuff/ProductImage";
import FiltersMixin from "@/assets/js/cls/FiltersMixin";
import FilterDictionary from "@/assets/js/cls/FilterDictionary";
import ReplaceSelect from "@/components/clStuff/ReplaceSelect";
import TypeSelect from "@/components/clStuff/TypeSelect";
// import SelectSoftType from "@/components/clStuff/SelectSoftType";

export default {
  name: "PriceList",
  components: {
    SetPricePopup,
    SoftTypeIcon,
    ProductImage,
    ReplaceSelect,
    TypeSelect,
    // SelectSoftType,
  },
  mixins: [UserMixin, ClCompanyMixin, FiltersMixin],
  props: {},
  data: function () {
    return {
      // filter: 0,
      priceData: null,
      loading: null,
      showOnlinePrices: true,
      filters: {
        ...FilterDictionary.filterDefaults,
        quantity: null,
        compare: 1,
      },
      filterDefaults: {
        ...FilterDictionary.filterDefaults,
        quantity: null,
        compare: 0,
      },
      // onlineIndex: 6, // the index for the "online" option in the headers arr
      headers: [
        { text: "Company", value: "company_id" },
        { text: "Lens", value: "name" },
        { text: "Type", value: "type" },
        { text: "Replace", value: "replace" },
        { text: "Rebate?", value: "rebateId" },
        { text: "Qty", value: "quantity" },
        { text: "Online*", value: "onlinePrice" },
        { text: "Practice", value: "practicePrice" },
      ],
    };
  },
  methods: {
    colorForPrice(row) {
      let rtn = "";
      if (!this.filters.compare) return null;
      let web = row.onlinePrice ? parseFloat(row.onlinePrice) : null;
      let practice = row.practicePrice ? parseFloat(row.practicePrice) : null;
      if (web && practice) rtn = web < practice ? "red--text" : "green--text";
      return rtn;
    },
    loadPrices() {
      let params = null;
      if (this.auth_credentials) {
        params = this.auth_credentials;
      } else {
        alert("Please log in to use this feature");
        return;
      }
      ApiServices.practicePrices(params)
        .then((response) => {
          this.priceData = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = "An API error occurred";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateLensPrice() {
      this.loadPrices(); // reload all the data? Or just try to update the changed items (to avoid problems related to persisting the filters & sorting)

      // need to put the returned data in a format similar to priceData
      // let new ={};
      // let boxes = data.practice?.boxes;
      // Object.entries(boxes).forEach(([box, row]) =>{
      //   let key = `${lens_id}-${row.box}`;
      //   new[key] = {};
      // });
    },
  },
  computed: {
    headersForSize: function () {
      let headers = [];
      let showOnline = this.filters.compare;
      this.headers.forEach(function (header) {
        let isOnline = header.value == "onlinePrice";
        let canShow = !isOnline || (isOnline && showOnline);
        if (canShow) headers.push(header);
      });
      return headers;
    },
    packageSizes: function () {
      let rtn = [];
      if (!this.priceData?.lenses) return null;
      this.priceData.lenses.forEach((row) => {
        const qty = row.quantity;
        if (!rtn.includes(qty)) rtn.push(qty);
      });
      return rtn
        .sort(function (a, b) {
          return a - b;
        })
        .map(String); // filters mixin needs a string
    },
    filterSummary: function () {
      let arr = [];
      const f = this.filters;
      if (f.name) arr.push({ label: `name like '${f.name}'`, filter: "name" });
      if (f.type && f.type != "ALL") {
        let tText = FilterDictionary.titleForOptionKey("type", f.type);
        arr.push({ label: tText, filter: "type" });
      }
      if (f.replace && f.replace != "ALL") {
        let rText = FilterDictionary.titleForOptionKey("replace", f.replace);
        arr.push({ label: rText, filter: "replace" });
      }
      if (f.quantity)
        arr.push({ label: `${f.quantity} packs`, filter: "quantity" });
      return arr;
    },
    lensList: function () {
      if (!this.priceData?.lenses) return [];
      //let rtn = [];
      const f = this.filters;
      if (!f) return this.pairs;
      const replaceFilter = FilterDictionary.daysArrayForReplacementKey(
        f.replace
      );
      const typeFilter = f.type && f.type != "ALL" ? f.type : null;
      const nameFilter = f.name && f.name != "" ? f.name : null;
      const quantityFilter = f.quantity && f.quantity > 0 ? f.quantity : null;
      console.log(typeFilter, replaceFilter);

      return this.priceData.lenses.filter((item) => {
        if (typeFilter && item.type_tag != typeFilter) return false;

        const quantity = item.quantity;
        // console.log(quantity, f.qty);
        if (quantity && quantityFilter && quantity != quantityFilter)
          return false;

        if (nameFilter) {
          const nameMatch =
            item.name.toLowerCase().indexOf(nameFilter.toLowerCase()) != -1;
          const companyMatch =
            item.company.toLowerCase().indexOf(nameFilter.toLowerCase()) != -1;
          if (!(nameMatch || companyMatch)) return false;
        }

        const lensDays = parseInt(item.replace);
        if (Array.isArray(replaceFilter) && replaceFilter.length > 0) {
          const replaceMatch = replaceFilter.includes(lensDays);
          if (!replaceMatch) return false;
        }
        return true;
      });

      // return this.priceData.lenses;
    },
  },
  mounted() {
    this.loadPrices();
    this.setFiltersFromHash(); // from mixin
    // this.filterDefaults.quantity = null;
    // this.filters.quantity = null;
  },
  metaInfo() {
    return {
      title: "EyeDock/Prices | CL Price List",
    };
  },
};
</script>

<style scoped>
/* todo - put in global css? */
.compact-select {
  transform: scale(0.77);
  transform-origin: left;
}
.cardOutline {
  border: 1px solid #e1dbcd !important;
}
.dataTable {
  border: 1px solid #e7e7e7 !important;
  margin-top: 2em !important;
}
</style>
